module.exports = __webpack_public_path__ + "img/vdara2.83782ad5.jpg";